import { ErrorCodes } from '@ringana/errors';
import { ILogin } from '@/common/interfaces/login.interface';
import FetchError from '@/errors/fetch-error';
import CookieHelper from '@/helpers/CookieHelper';
import LocalStorageHelper from '@/helpers/LocalStorageHelper';
import NewsHelper from '@/helpers/NewsHelper';
import SentryHelper from '@/helpers/SentryHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import ValidationHelper from '@/helpers/ValidationHelper';
import ZApiService from '@/services/ZApiService';
import CartService from '@/services/CartService';

export default class LoginService {
  private zApiService: ZApiService;
  private cartService: CartService;

  constructor(zApiService: ZApiService, cartService: CartService) {
    this.zApiService = zApiService;
    this.cartService = cartService;
  }

  public async afterSuccessfulLogin(data: ILogin): Promise<void> {
    CookieHelper.removeAuthToken();
    CookieHelper.removeCartSession();
    CookieHelper.removeDeliveryAddressIso();
    LocalStorageHelper.removeLoginInformation();

    CookieHelper.setAuthToken(data.account.authToken);
    CookieHelper.setCartSession(data.session);
    CookieHelper.setCurrency(data.currency);
    CookieHelper.setDeliveryAddressIso(data.deliveryAddressIso);
    LocalStorageHelper.setPersonalInfo(data);

    LocalStorageHelper.setCartItemsCount(await this.zApiService.getCartCount());
    await LoginService.setNewNewsPostsIDsAndCountInLocalStorage();

    if(window.sentryInitialized) {
      SentryHelper.setSentryTags();
    }

    try {
      await this.cartService.fetchCart();
    } catch (err) {
      if(!(err instanceof FetchError && err.errorCode === ErrorCodes.LIMITING_BOUNCER_ACTIVE)) {
        throw err;
      }
      // all good, hodor should be active now
    }

    const loginRedirect = SessionStorageHelper.getRedirect();
    SessionStorageHelper.removeRedirect();
    if(loginRedirect && ValidationHelper.checkIfTargetIsValidLoginRedirectTarget(loginRedirect)) {
      window.location.href = loginRedirect;
    } else {
      window.location.href = `/`;
    }
  }

  private static async setNewNewsPostsIDsAndCountInLocalStorage(): Promise<void> {
    const newNews = await NewsHelper.getNewNewsPostsIDsAndCount();

    LocalStorageHelper.setNewNewsCount(newNews.count);
    LocalStorageHelper.setNewNewsPostsIDS(newNews.IDs);
  }
}
